import { Link } from "gatsby"
import React from "react"
import * as style from "./style.module.css"
import Map from "/src/components/Map"
import PageTop from "/src/components/PageTop"
import json from "/src/siteData.json"
import Logo from "/src/images/common/logo.png"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"
import MapIcom from "/src/images/icon/map.png";
import PhoneIcom from "/src/images/icon/phone.png";

const data = json.footer
const siteMetaData = json.siteMetadata
const phonenumber = data.phoneNumber

const Component = () => {
  return (
    <>
      <Map address={data.address} />
      <PageTop showBelow={900} />
      <footer className={style.footer}>
        <div className={"content"}>
          <div className={style.footer_group}>
            <div className={style.footerTop}>
              <Link to="/" className={style.footer_logo}>
                <img
                  src={Logo}
                  alt={siteMetaData.title}
                  style={{ objectFit: "contain" }}
                />
              </Link>
            </div>
            <table className={style.footer_adress_group}>
              <tbody>
                <tr>
                  <th>
                    <img src={MapIcom} alt="" />
                  </th>
                  <td>
                    〒133-0051<br />
                    東京都江戸川区北小岩6-42-4　美喜荘　1号
                  </td>
                </tr>
                <tr>
                  <th>
                    <img src={PhoneIcom} alt="" />
                  </th>
                  <td>
                    <Link to={`tel:${phonenumber}`}>
                      {phonenumber}
                    </Link>
                  </td>
                </tr>

              </tbody>
            </table>
            <ul className={style.footer_linklist}>
              <li>
                <Link to={"/"}><p>Home</p></Link>
              </li>
              <li>
                <Link to={getPathFromTemplateType(3)}><p>Service</p></Link>
              </li>
              <li>
                <Link to={"/staff"}><p>Staff</p></Link>
              </li>
              <li>
                <Link to={"/voice"}><p>Voice</p></Link>
              </li>
              <li>
                <Link to={"/company"}><p>Company</p></Link>
              </li>
              <li>
                <Link to={getPathFromTemplateType(4)}><p>News</p></Link>
              </li>
              <li>
                <Link to={"/recruit"}><p>Recruit</p></Link>
              </li>
              <li>
                <Link to={getPathFromTemplateType(6)}><p>Contact</p></Link>
              </li>

            </ul>
          </div>
          <div>
            <Link
              className={style.privacy_policy_link}
              to={getPathFromTemplateType(5)}
            >
              Privacy Policy
            </Link>            
          </div>
          <small className={style.copyright}>&copy; {data.copyright}</small>
        </div>
      </footer>
    </>
  )
}

export default Component
